let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8SIRU")).then(() => parcelRequire('icwl2'));